// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"4d519ffa","87":"2376a053","322":"87be978d","454":"4dc5de20","469":"58b00bac","602":"0c08f42d","766":"94d356c3","829":"439e7bf2","854":"08ff0392","919":"85366fb7","924":"cf3954f4","940":"2376a053"}[chunkId] + ".chunk.css";
};